.trigger {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-xs);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: inherit;
  font: inherit;
  font-weight: 600;
}

.triggerIcon {
  transition: transform 0.2s ease;
}

.trigger[aria-expanded="true"] .triggerIcon {
  transform: rotate(180deg);
}

.content {
  display: flex;
  flex-direction: column;
  z-index: var(--z-index-layer-dropdown);
  overflow: hidden auto;
  max-height: var(--radix-popper-available-height);
  border-radius: var(--radius-lg);
  border: var(--border-width-default) solid var(--border-default);
  background-color: var(--surface-raised);
  box-shadow: var(--shadow-floating);
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
  max-width: max-content;
  margin-left: auto;
  color: var(--content-primary);
  box-sizing: border-box;
  padding: var(--spacing-md);
  gap: var(--spacing-xs);
}

.content[data-state="open"] {
  animation: contentFadeIn 200ms ease;
}

.content[data-state="closed"] {
  animation: contentFadeOut 200ms ease;
}

.content[data-side="bottom"] {
  animation-name: slideInFromTop;
}

.content[data-side="left"] {
  animation-name: slideInFromRight;
}

.content[data-side="right"] {
  animation-name: slideInFromLeft;
}

.content[data-side="top"] {
  animation-name: slideInFromBottom;
}

.item {
  padding: var(--spacing-sm) var(--spacing-md);
  display: flex;
  height: unset;
  border-radius: var(--radius-lg);
  background: var(--surface-raised);
  color: var(--content-primary);
  font: var(--body-md-font);
  letter-spacing: var(--body-md-letter-spacing);
  outline: none;
  cursor: pointer;
}

.item:focus {
  background-color: var(--surface-action-navigation-hover);
}

.item[data-disabled] {
  pointer-events: none;
  color: var(--content-on-action-disabled);
  background-color: var(--surface-action-disabled);
}

.item:hover {
  background-color: var(--surface-action-navigation-hover);
}

.item.selected {
  background-color: var(--surface-action-selection-active);
}

.destructive {
  color: var(--content-status-error);
}

.inset {
  padding-left: var(--spacing-xl);
}

.itemIndicatorWrapper {
  position: absolute;
  left: var(--spacing-md);
  display: flex;
  height: var(--spacing-lg);
  width: var(--spacing-lg);
  align-items: center;
  justify-content: center;
}

.label {
  padding: var(--spacing-sm) var(--spacing-md);
  font-size: var(--text-md);
  font-weight: 600;
  color: var(--content-primary);
}

.separator {
  margin: var(--spacing-xs) calc(-1 * var(--spacing-md));
  height: 1px;
  background-color: var(--border-subtle);
}

.shortcut {
  margin-left: auto;
  font-size: var(--text-xs);
  letter-spacing: 0.05em;
  color: var(--content-secondary);
}

@keyframes contentFadeIn {
  0% {
    opacity: 0;
    transform: translateY(calc(-1 * var(--spacing-md)));
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes contentFadeOut {
  0% {
    opacity: 1;
    transform: translateY(0);
  }

  100% {
    opacity: 0;
    transform: translateY(calc(-1 * var(--spacing-md)));
  }
}

@keyframes slideInFromTop {
  0% {
    opacity: 0;
    transform: translateY(calc(-1 * var(--spacing-md)));
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInFromRight {
  0% {
    opacity: 0;
    transform: translateX(var(--spacing-md));
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInFromLeft {
  0% {
    opacity: 0;
    transform: translateX(calc(-1 * var(--spacing-md)));
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInFromBottom {
  0% {
    opacity: 0;
    transform: translateY(var(--spacing-md));
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
